import {httpService} from "@/modules/common/services";
import {getQuery, putQuery} from "@/modules/common/utils";

const saveExternalCard = async (clientId, token, cardholderName) => {
  const params = {client_id: clientId, token, cardholder_name: cardholderName}
  const response = await httpService.post('platform/v1/payment/cards', params);
  return response;
}

const updateCardScope = async (cardId, scope) => {
  const params = {
    card: { usage_permission: scope },
    new_api: true
  }
  return putQuery(`/business/payments/v1/cards/${cardId}`, params)

}

const fetchCardRequest = async (clientUid) => {
  return await getQuery(`/business/payments/v1/card_requests/${clientUid}`, {new_api: true})
}

export default {
  saveExternalCard,
  updateCardScope,
  fetchCardRequest,
}
